import { apiGet, apiPatch, apiPost } from "./client";
import type {
  CrmConnectionStatus,
  IntegrationsStatus,
} from "@sales-ops-amplify/shared";

export type { IntegrationsStatus };

export interface HubSpotSyncResult extends CrmConnectionStatus {
  message?: string;
  companies: { created: number; updated: number; fetched?: number; truncated?: boolean };
  contacts: { created: number; updated: number; fetched?: number; truncated?: boolean };
  deals: { created: number; updated: number; fetched?: number; truncated?: boolean };
  portalId?: string;
  warnings?: string[];
}

export async function getIntegrationsStatus(): Promise<IntegrationsStatus> {
  return apiGet<IntegrationsStatus>("/api/crm/integrations");
}

export async function connectApollo(apiKey: string): Promise<{
  connected: boolean;
  message?: string;
}> {
  return apiPost("/api/crm/apollo/connect", { apiKey });
}

export async function disconnectApollo(): Promise<{ connected: boolean }> {
  return apiPost("/api/crm/apollo/disconnect");
}

export async function connectNewsApi(apiKey: string): Promise<{
  connected: boolean;
  message?: string;
}> {
  return apiPost("/api/crm/newsapi/connect", { apiKey });
}

export async function disconnectNewsApi(): Promise<{ connected: boolean }> {
  return apiPost("/api/crm/newsapi/disconnect");
}

export async function getHubSpotStatus(): Promise<CrmConnectionStatus> {
  return apiGet<CrmConnectionStatus>("/api/crm/hubspot/status");
}

export async function connectHubSpot(
  accessToken: string,
  stageMap?: Record<string, string>,
): Promise<{
  connected: boolean;
  portalId?: string;
  message?: string;
}> {
  return apiPost("/api/crm/hubspot/connect", {
    accessToken,
    ...(stageMap && Object.keys(stageMap).length ? { stageMap } : {}),
  });
}

export async function disconnectHubSpot(): Promise<{ connected: boolean }> {
  return apiPost("/api/crm/hubspot/disconnect");
}

export async function syncHubSpot(): Promise<HubSpotSyncResult> {
  return apiPost<HubSpotSyncResult>("/api/crm/hubspot/sync");
}

export async function saveHubSpotStageMap(
  stageMap: Record<string, string>,
): Promise<{ stageMap: Record<string, string>; message?: string }> {
  return apiPatch("/api/crm/hubspot/stage-map", { stageMap });
}

export async function retryFailedHubSpotOutbox(): Promise<{
  reset: number;
  message?: string;
}> {
  return apiPost("/api/crm/hubspot/outbox/retry");
}
